<!-- HERO SECTION -->
<section class="hero-wrapper full-hero">

  <div class="hero-content">

    <h1 class="hero-title center">
      GCSE Help Club for Year 9
    </h1>

    <h3 class="hero-subtitle center">
      Free Weekly Academic Support for GCSE Exam Excellence
    </h3>

    <p class="hero-desc center">
      Weekly online club designed to strengthen core skills, build GCSE exam awareness, and nurture a love for learning, all in a supportive and pressure-free environment.
    </p>

    <div class="hero-info center-row">
      <div class="info-pill">📅 Every Tuesday</div>
      <div class="info-pill">⏰ 4:00 – 5:00 PM (UK)</div>
      <div class="info-pill">💻 Live Online Sessions</div>
      <div class="info-pill yellow">✔ Completely Free</div>
    </div>

    <button class="hero-btn big-btn" (click)="openForm()">
  JOIN FREE NOW
</button>


  </div>

</section>



<!-- WHAT IS SECTION -->
<section class="info-section">

  <div class="info-card">

    <div class="info-left">
      <h2>What Is the GCSE Help Club?</h2>

      <p>
        The GCSE Help Club is a structured, tutor-led online support session
        that helps Year 9 students transition smoothly into GCSE-level learning.
        Sessions focus on clarity, practice, and exam awareness while keeping
        learning engaging and stress-free.
      </p>

      <p class="highlight">
        It’s the perfect bridge between Key Stage 3 and GCSE success.
      </p>
    </div>

    <div class="info-right">
      <img src="assets/images/img11gcsehelpclub.png">
    </div>

  </div>

</section>


<!-- EXAM BOARDS -->
<section class="board-section">

  <div class="board-card">

    <h2>GCSE Exam Boards Covered</h2>

    <div class="boards">
      <div class="board">AQA</div>
      <div class="board">OCR</div>
      <div class="board">Edexcel</div>
    </div>

    <p>
      Content is exam-relevant, skills-focused, and adaptable across specifications.
    </p>

  </div>

</section>


<!-- SUBJECTS COVERED -->
<section class="subjects-section">
  <div class="subjects-card">

    <h2>Subjects Covered</h2>

    <div class="subjects-grid">

      <div class="subject-box">
        <img src="assets/images/img6gcsehelpclub.jpg" />
        <p>GCSE Maths</p>
      </div>

      <div class="subject-box">
        <img src="assets/images/img7gcsehelpclub.jpg" />
        <p>GCSE English</p>
      </div>

      <div class="subject-box">
        <img src="assets/images/img8gcsehelpclub.jpg" />
        <p>GCSE Science</p>
      </div>

      <div class="subject-box">
        <img src="assets/images/img9gcsehelpclub.jpg" />
        <p>GCSE Computer Science</p>
      </div>

    </div>

    <p class="subject-note">
      Each session is designed to improve understanding, accuracy, and confidence.
    </p>

  </div>
</section>


<!-- WHAT STUDENTS WILL GAIN -->
<section class="gain-section">

  <div class="gain-card">

    <div class="gain-left">
      <h2>What Students Will Gain</h2>

      <ul class="gain-list">

  <li>
    <strong>Regular Online Classes</strong>
    <span>Weekly live lessons with experienced GCSE tutors.</span>
  </li>

  <li>
    <strong>Practice Sheets & GCSE Exam-Style Questions</strong>
    <span>Targeted worksheets to reinforce learning.</span>
  </li>

  <li>
    <strong>Result Analysis</strong>
    <span>Clear breakdowns to highlight strengths and gaps.</span>
  </li>

  <li>
    <strong>Review & Constructive Feedback</strong>
    <span>Actionable feedback for improvement.</span>
  </li>

  <li>
    <strong>GCSE Exam Tips & Tricks</strong>
    <span>Early exam strategy exposure.</span>
  </li>

</ul>

    </div>

    <div class="gain-right">
      <img src="assets/images/img5gcsehelpclub.jpg" />
    </div>

  </div>
</section>


<!-- WHY JOIN -->
<section class="why-section">

  <div class="why-card">

    <h2>Why Join the GCSE Help Club in Year 9?</h2>

    <div class="why-grid">
      <p>✔ Build strong foundations before the syllabus intensifies</p>
      <p>✔ Develop independent study habits</p>
      <p>✔ Gain confidence across core subjects</p>
      <p>✔ Reduce stress in Years 10 and 11</p>
    </div>

  </div>

</section>


<!-- WHO IS THIS FOR -->
<section class="who-wrap">
  <div class="who-card">

    <h2>Who Is This GCSE Help Club For?</h2>

    <div class="who-grid">

      <div class="who-pill">
        Year 9 students starting GCSE-level learning
      </div>

      <div class="who-pill">
        Parents seeking free, expert GCSE support
      </div>

      <div class="who-pill">
        Students needing structured guidance and practice
      </div>

      <div class="who-pill">
        Families looking to build confidence without pressure
      </div>

    </div>

  </div>
</section>


<!-- FINAL CTA -->
<section class="cta-wrap">

  <div class="cta-box">

    <h2>Why Choose Sehyog Academy?</h2>

    <p class="cta-sub">
      Trusted by more than <strong>10K Successful Students and Happy Parents</strong> across UK
    </p>

    <div class="cta-points">
      <span>✔ Experienced GCSE tutors with proven results</span>
      <span>✔ Clear explanations and student-friendly teaching</span>
      <span>✔ Focus on long-term academic success</span>
      <span>✔ We help students understand, not memorise</span>
    </div>

    <button class="cta-btn" (click)="openForm()">
  Enrol For Free →
</button>

  </div>

</section>

